<template>
  <div class="container">
    <Loading v-model:active="loading" loader="dots" />
    <div class="shadow-lg p-5 mx-auto my-5 rounded-3 w-md-50">
      <div class="row">
        <div class="col-md-12">
          <h1>{{ $t('account.changePassword') }}</h1>
          <br />
          <h4>{{ $t('account.changeOrUpdatePassword') }}</h4>
        </div>
      </div>
      <PasswordForm :id="analystId" :email="email" :updatePassword="updatePassword" />
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue'
import { useAnalystStore } from '@/stores/analyst.store'
import { storeToRefs } from 'pinia'
import PasswordForm from '@/components/PasswordForm.vue'
import Loading from 'vue-loading-overlay'

const { fetchPersonalInfo, updatePassword } = useAnalystStore()
const { email, analystId, loading } = storeToRefs(useAnalystStore())

onBeforeMount(() => {
  fetchPersonalInfo()
})

</script>

<style lang="scss" scoped>
.w-md-50 {
  width: 50%;
}

@media (max-width: 768px) {
  .w-md-50 {
    width: 100%;
  }
}
</style>
